@if (report && result) {
    <p-panel
        [header]="
            ('cs.bia.analysis.infoAnalysis' | hisUi) +
            ': ' +
            (report.name
                ? report.name + ' (' + result.info?.lastUpdateBiad + ')'
                : result.info?.lastUpdateBiad)
        "
        [toggleable]="true"
        [collapsed]="true" >
        <div>
            <strong>{{ "cs.bia.analysis.name" | hisUi }}:</strong> {{ report.name }}
        </div>
        <div>
            <strong>{{ "cs.bia.analysis.description" | hisUi }}:</strong> {{ report.description }}
        </div>
        <div>
            <strong>{{ "cs.bia.analysis.subjectArea" | hisUi }}:</strong>
            {{ result.info?.sachgebiete?.join(", ") }}
        </div>
        <div>
            <strong>{{ "cs.bia.analysis.topic" | hisUi }}:</strong>
            @if (result.info?.theme) {
                <span> {{ result.info?.theme?.caption }} </span>
            } @else {
                @for (factTable of result.info?.facttables; track factTable) {
                    @if (factTable.description) {
                        <abbr [title]="factTable.description"> {{ factTable.caption }}</abbr>
                    } @else {
                        {{ factTable.caption }}
                    }
                    @if (!$last) {
                        ,
                    }
                }
            }
        </div>
        <div>
            <span><strong>{{ "cs.bia.analysis.measures" | hisUi }}:</strong>
                @for (measure of result.info?.measures; track measure) {
                    @if (measure.description) {
                        <abbr [title]="measure.description"> {{ measure.caption }} </abbr>
                    } @else {
                        {{ measure.caption }}
                    }
                    @if (!$last) {
                        ,
                    }
                }
            </span>
        </div>
        <div>
            <span><strong>{{ "cs.bia.analysis.rowAttributes" | hisUi }}:</strong>
                @for (
                    leftDimensionAttribute of result.info?.leftDimensionAttributes;
                    track leftDimensionAttribute
                ) {
                    @if (leftDimensionAttribute.description) {
                        <abbr [title]="leftDimensionAttribute.description">
                            {{ leftDimensionAttribute.caption }}</abbr
                        >
                    } @else {
                        {{ leftDimensionAttribute.caption }}
                    }
                    @if (!$last) {
                        ,
                    }
                }
            </span>
        </div>
        <div>
            <span><strong>{{ "cs.bia.analysis.columnAttributes" | hisUi }}:</strong>
                @for (
                    topDimensionAttribute of result.info?.topDimensionAttributes;
                    track topDimensionAttribute
                ) {
                    @if (topDimensionAttribute.description) {
                        <abbr [title]="topDimensionAttribute.description">
                            {{ topDimensionAttribute.caption }}</abbr
                        >
                    } @else {
                        {{ topDimensionAttribute.caption }}
                    }
                    @if (!$last) {
                        ,
                    }
                }
            </span>
        </div>
        <div>
            <span><strong>{{ "cs.bia.analysis.filter" | hisUi }}: </strong>
                @for (filter of result.info?.filter; track filter) {
                    <strong>{{ filter.substring(1, filter.indexOf(")")) }})</strong>
                    {{ filter.substring(filter.indexOf(")") + 1) }}
                    @if (!$last) {
                        ,
                    }
                }
            </span>
        </div>
        <div>
            <span><strong>{{ "cs.bia.analysis.connection" | hisUi }} </strong>
                @for (
                    secondaryFacttable of result.info?.secondaryFacttables;
                    track secondaryFacttable
                ) {
                    {{ secondaryFacttable }}
                    @if (!$last) {
                        ,
                    }
                }
            </span>
        </div>
        <div>
            <span>
                <strong>{{ "cs.bia.analysis.columns.hideEmpty.checkbox" | hisUi }}:</strong>
                {{ result.info?.hideEmptyColumns }}
            </span>
        </div>
        <div>
            <span>
                <strong>{{ "cs.bia.analysis.lastUpdateBAD" | hisUi }}</strong>
                {{ result.info?.lastUpdateBiad }}
            </span>
        </div>
    </p-panel>
}